import { FieldDescription } from '@azelis/ui/components/field';

import type { SharePointDocument } from '@/api/types';

import { DocumentsColumn } from './documents-column';

/** Right column: read-only summary of every document selected so far, across all drives. */
export function SelectedDocumentsColumn({
  selectedDocuments,
}: {
  selectedDocuments: Array<SharePointDocument>;
}) {
  return (
    <DocumentsColumn
      className="w-[196px] shrink-0"
      title={`Selected Documents (${selectedDocuments.length})`}
    >
      {selectedDocuments.length > 0 ? (
        <ul className="flex flex-col gap-4">
          {selectedDocuments.map((document) => (
            <li key={document.id}>
              <FieldDescription className="truncate">{document.filename}</FieldDescription>
            </li>
          ))}
        </ul>
      ) : null}
    </DocumentsColumn>
  );
}
